// src/components/InfoCard/InfoCard.js
import React from 'react';
import './InfoCard.css';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';

const InfoCard = ({
  image,
  heading,
  text,
  backgroundColor,
  textColor,
  headingColor,
  headingSize,
  infoCardWidth,
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const animationProps = useSpring({
    transform: inView ? 'scale(1)' : 'scale(0.9)',
    opacity: inView ? 1 : 0,
    config: { tension: 170, friction: 20 },
  });

  // Function to render text as paragraphs
  const renderTextAsParagraphs = text => {
    // Split text by periods followed by space and capital letter, or by line breaks
    const sentences = text.split(/(?<=\.)\s+(?=[A-Z])|(?<=\.)\s*\n+/);

    return sentences.map((sentence, index) => (
      <p key={index} className="info-card-paragraph">
        {sentence.trim()}
      </p>
    ));
  };

  // Function to format heading to ensure it spans 2 lines
  const formatHeadingForTwoLines = heading => {
    const words = heading.split(' ');
    if (words.length <= 1) {
      return heading; // Single word, can't split
    }

    // Split roughly in the middle
    const midpoint = Math.ceil(words.length / 2);
    const firstLine = words.slice(0, midpoint).join(' ');
    const secondLine = words.slice(midpoint).join(' ');

    return (
      <>
        {firstLine}
        <br />
        {secondLine}
      </>
    );
  };

  return (
    <animated.div
      ref={ref}
      style={{ ...animationProps, backgroundColor, width: infoCardWidth }}
      className="info-card"
    >
      <img src={image} alt={heading} className="info-card-image" />
      <h2
        className="info-card-heading"
        style={{ color: headingColor, fontSize: headingSize }}
      >
        {formatHeadingForTwoLines(heading)}
      </h2>
      <div className="info-card-text-container">
        {renderTextAsParagraphs(text)}
      </div>
    </animated.div>
  );
};

export default InfoCard;
